import { jsx as _jsx } from "react/jsx-runtime";
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { ALL_MODEL_LABELS, ASSISTANT_DISPLAY_NAME, MODEL_OPTIONS, } from '../../constants/assistant.constants';
import BadgeContent from './Content';
export const ModelBadge = ({ modelId }) => {
    const { app } = usePlatform();
    const modelOption = MODEL_OPTIONS.find((option) => option.value === modelId);
    const modelLabel = (modelOption === null || modelOption === void 0 ? void 0 : modelOption.label) || ALL_MODEL_LABELS[modelId] || modelId;
    return (_jsx(BadgeContent, { authorName: app === 'client' ? ASSISTANT_DISPLAY_NAME : modelLabel, groupName: app === 'admin' ? ASSISTANT_DISPLAY_NAME : undefined }));
};
